module.exports = {
  FLOW_HIDDEN_CLASS: 'flow-hidden',
  FLOW_LOCALIZED_CLASS: 'flow-localized',
};



// WEBPACK FOOTER //
// ./static/js/v0/utilities/tags/constants.js